import React from 'react'
import styles from './CertificationsSection.module.css'
import { certifications } from '../../../data/certifications'

const CertificationsSection = () => {
  return (
    <section id="certifications" className={styles.certifications}>
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.sectionLabel}>Certifications</span>
          <h2 className={styles.sectionTitle}>Professional Credentials</h2>
          <p className={styles.sectionDescription}>
            Industry-recognized certifications validating expertise in cloud architecture and modern technologies
          </p>
        </div>

        <div className={styles.certificationsGrid}>
          {certifications.map((cert) => (
            <div key={cert.id} className={styles.certCard}>
              <div className={styles.certHeader}>
                <div className={styles.certLogo}>
                  <img src={cert.logo} alt={cert.issuer} />
                </div>
                <div className={styles.certMeta}>
                  <span className={styles.certDate}>{cert.date}</span>
                </div>
              </div>
              
              <h3 className={styles.certName}>{cert.name}</h3>
              <p className={styles.certIssuer}>{cert.issuer}</p>
              <p className={styles.certDescription}>{cert.description}</p>
              
              <div className={styles.certSkills}>
                {cert.skills.slice(0, 3).map((skill, index) => (
                  <span key={index} className={styles.skillTag}>{skill}</span>
                ))}
              </div>
              
              <div className={styles.certFooter}>
                <span className={styles.credentialId}>ID: {cert.credentialId}</span>
                <a 
                  href={cert.verificationUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className={styles.verifyLink}
                >
                  Verify →
                </a>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}

export default CertificationsSection